module.exports = __webpack_public_path__ + "static/img/014.bedf963.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/014.jpg
// module id = 222
// module chunks = 1